<template>
  <div v-if="pending.length" class="rounded-lg border border-primary/30 bg-primary/5 p-4" data-testid="student-data-requests">
    <div class="mb-3 flex flex-wrap items-center justify-between gap-3">
      <div>
        <h3 class="text-base font-semibold">Your school needs some details from you</h3>
        <p class="text-sm text-surface-600">Fill them in on your profile. It only takes a minute.</p>
      </div>
      <Button label="Fill them in" icon="pi pi-arrow-right" iconPos="right" size="small" data-testid="btn-data-requests-fill"
        @click="goToForm" />
    </div>
    <div class="grid gap-3 md:grid-cols-2">
      <StudentDataRequestPreview v-for="request in pending" :key="request.id" :title="request.title" :message="request.message"
        :dueLabel="dueText(request.due_on)" :fields="request.fields" :data-testid="`student-data-request-${request.id}`">
        <p class="mt-2 text-xs text-surface-500">{{ myRequestProgress(request) }}</p>
      </StudentDataRequestPreview>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useMyStudentDataRequests } from '@/composables/queries/useMyStudentDataRequests';
import StudentDataRequestPreview from '@/components/StudentDashboard/DataRequests/StudentDataRequestPreview.vue';
import { PROFILE_FORM_ROUTE, actionableRequests, dueText, myRequestProgress } from '@/utils/studentDataRequests';

/** The student's unanswered data requests on their home page, with a way to their profile form. */
const router = useRouter();
const { requests } = useMyStudentDataRequests();
const pending = computed(() => actionableRequests(requests.value));

function goToForm() {
  router.push(PROFILE_FORM_ROUTE);
}
</script>
